import React from 'react';
import { Stack } from '@mui/material';

import type { VoidFn } from '../../../types/common';

export interface LocationSelectorProps {
  locationQuery: string;
  onChangeLocationQuery: VoidFn<string>;
}

export const Selector = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      width="100%"
      sx={{
        position: 'relative',
        width: '100%',
        borderRadius: '50px',
        height: '100%',
        border: '10px solid white',
        padding: '15px 10px 0px 10px',

        display: 'flex',
        alignItems: 'center',
        transition: 'all 0.3s linear',
        justifyContent: 'flex-start',
        '&:hover, &:focus-within': {
          backgroundColor: 'rgba(255, 197, 204, 0.2)',
          cursor: 'pointer',
        },
        '& .MuiInputBase-root': {
          backgroundColor: 'transparent',
        },
        '& .MuiInputBase-input:focus': {
          backgroundColor: 'transparent',
        },
        '& input::selection': {
          backgroundColor: 'transparent',
          color: 'inherit',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '& .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-endAdornment':
          {
            right: '3px',
            top: '15px',
          },
      }}
    >
      {children}
    </Stack>
  );
};
